const statuses = new Set([
  'in_progress', 'ended', 'missed', 'rejected', 'failed', 'incoming', 'ringing', 'active',
]);

export function callStatusLabel(t, status) {
  const key = statuses.has(status) ? status.toUpperCase() : 'UNKNOWN';
  return t(`VOIP_DISPOSITION.CALL_STATUS.${key}`);
}

export function callDirectionLabel(t, direction) {
  const key = ['inbound', 'outbound'].includes(direction)
    ? direction.toUpperCase()
    : 'UNKNOWN';
  return t(`VOIP_DISPOSITION.CALL_DIRECTION.${key}`);
}

// Perfil vem do scoring em inglês ou português, em qualquer caixa
// (HOT, quente...). Valor desconhecido aparece como veio.
const PROFILE_KEYS = {
  hot: 'HOT',
  quente: 'HOT',
  warm: 'WARM',
  morno: 'WARM',
  cold: 'COLD',
  frio: 'COLD',
};

export function leadProfileLabel(t, profile) {
  const key = PROFILE_KEYS[String(profile || '').trim().toLowerCase()];
  return key ? t(`VOIP_CALLS.PROFILE.${key}`) : profile || '';
}

// Duração de ligação em m:ss (ou h:mm:ss), no lugar dos segundos crus.
export function formatCallDuration(seconds) {
  const total = Math.max(0, Math.round(Number(seconds) || 0));
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = String(total % 60).padStart(2, '0');
  if (h > 0) return `${h}:${String(m).padStart(2, '0')}:${s}`;
  return `${m}:${s}`;
}
